document.addEventListener("DOMContentLoaded", () => {

  function mosaicSort() {
    const sections = document.querySelectorAll('.blog-section');

    // if window width above 1024px

    if (window.innerWidth < 1024) {
      sections.forEach((section) => {
        section.style.marginTop = '0px';
      })
      return;
    }


    console.log('resixed');

    sections.forEach((section, i) => {
      const sectionHeight = section.offsetHeight;
      const sectionContentHeight = section.querySelector('.blog-section-inner').offsetHeight;

      if (sectionContentHeight != sectionHeight) {
        const difference = sectionHeight - sectionContentHeight;

        if (sections[i + 2]) {
          sections[i + 2].style.marginTop = `-${difference}px`;
        }
      }
    })
  }

  mosaicSort()
  // on resize
  window.addEventListener('resize', () => {
    mosaicSort()
  })


})